<template>
  <div id="globalNewParams" class="warp">
    <!-- 头部搜索栏 -->
    <div>
      <div class="head_search">
        <div style="margin-right: 20px">
          <el-button
            type="primary"
            size="mini"
            class="edit-button"
            @click="getList"
          >筛选</el-button>
          <el-button
            type="warning"
            size="mini"
            @click="resetEvent()"
          >重置</el-button>
        </div>
        <div class="item_warp">
          <label style="width: 54px">手机号</label>
          <el-input
            v-model="userPhone"
            placeholder="请输入手机号"
            style="width: 150px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="width: 44px">姓名</label>
          <el-input
            v-model="userName"
            placeholder="请输入姓名"
            style="width: 150px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="width: 74px">创建时间</label>
          <el-date-picker
            v-model="dateTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </div>
      </div>
    </div>
    <!-- 表单 -->
    <div class="table_warp">
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="userTable"
        border
        style="width: 1531px"
        height="calc(100vh - 320px )"
        size="mini"
      >
        <!-- <el-table-column type="selection" width="50" /> -->
        <!-- 备注 -->
        <el-table-column prop="userId" label="用户ID" width="80" />
        <el-table-column prop="userPhone" label="用户账号" width="200" />
        <el-table-column prop="userName" label="用户姓名" width="200" />
        <el-table-column prop="queTitle" label="问卷名称" width="200" />
        <el-table-column prop="isTip" label="是否提醒" width="100">
          <template slot-scope="scope">
            <div :style="{ color: scope.row.isTip ? '#e74c3c' : '#000000' }">
              {{ scope.row.isTip ? "提醒" : "无" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="referenceId"
          label="操作或付款(单ID)"
          width="200"
        />
        <el-table-column prop="referenceType" label="服务类型" width="150" />

        <!-- 创建时间-->
        <el-table-column prop="createdAt" label="创建时间" width="200">
          <template slot-scope="scope">
            {{
              $parseTime(
                new Date(scope.row.createdAt),
                "{y}-{m}-{d} {h}:{i}:{s}"
              )
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-view"
              @click="checkEvent(scope.row)"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNumber"
      :limit.sync="pageSize"
      :page-sizes="[2, 5, 10, 20, 50]"
      @pagination="next()"
    />

    <!-- 添加弹窗 -->
    <el-dialog
      title="答卷详情"
      :visible.sync="dialogVisible"
      width="900px"
      :close="handleClose"
      :close-on-click-modal="false"
      :center="true"
      style="height: 90vh; margin-top: 40px"
    >
      <el-form ref="form" :model="formData" label-width="220px" size="mini">
        <el-form-item label="问卷名称">
          <el-input
            v-model="formData.queTitle"
            placeholder="请输入文章标题"
            style="width: 300px"
            size="mini"
            clearable
          />
        </el-form-item>
        <el-form-item
          v-for="(item, index) in questionList"
          :key="index"
          label=""
        >
          <div
            v-if="item.queType == 1 || item.queType == 2"
            class="questiontype"
          >
            <div class="questiontype_head">
              <div>{{ item.queType == 1 ? "单选题" : "多选题" }}</div>
              <div v-if="item.isTip" class="questiontype_head_right">
                <div class="questiontype_head_right_card">
                  <img
                    src="../../../static/warning.png"
                    style="width: 18px; height: 18px"
                    alt=""
                  >
                </div>
              </div>
            </div>
            <div>
              <div>题目</div>
              <el-input
                v-model="item.title"
                style="width: 380px"
                size="mini"
                clearable
              />
            </div>
            <div>
              <div>选项</div>
              <el-input
                v-model="item.options"
                type="textarea"
                style="width: 380px"
                size="mini"
                clearable
                :rows="5"
              />
            </div>
            <div>
              <div>触发提醒选项</div>
              <el-input
                v-model="item.remind"
                type="textarea"
                style="width: 380px"
                size="mini"
                clearable
              />
            </div>
            <div>答案：{{ item.answer || "暂无答案" }}</div>
          </div>
          <div v-if="item.queType == 3" class="questiontype">
            <div class="questiontype_head">
              <div>五星评比</div>
              <div v-if="item.isTip" class="questiontype_head_right">
                <div class="questiontype_head_right_card">
                  <img
                    src="../../../static/warning.png"
                    style="width: 18px; height: 18px"
                    alt=""
                  >
                </div>
              </div>
            </div>
            <div>
              <div>题目</div>
              <el-input
                v-model="item.title"
                style="width: 380px"
                size="mini"
                clearable
              />
            </div>
            <div>
              <div>低于几星答卷提醒</div>
              <el-input
                v-model="item.remind"
                style="width: 380px"
                size="mini"
                clearable
              />
            </div>
            <div>答案：{{ item.answer || "暂无答案" }}</div>
          </div>
          <div v-if="item.queType == 4" class="questiontype">
            <div class="questiontype_head">
              <div>填空题</div>
              <div v-if="item.isTip" class="questiontype_head_right">
                <div class="questiontype_head_right_card">
                  <img
                    src="../../../static/warning.png"
                    style="width: 18px; height: 18px"
                    alt=""
                  >
                </div>
              </div>
            </div>
            <div>
              <div>题目</div>
              <el-input
                v-model="item.title"
                style="width: 380px"
                size="mini"
                clearable
              />
            </div>
            <div>
              <div>以下什么情况答卷提醒</div>
              <div>
                <el-radio
                  v-model="item.remind"
                  label="用户有填写"
                >用户有填写</el-radio>
                <el-radio
                  v-model="item.remind"
                  label="用户无填写"
                >用户无填写</el-radio>
                <el-radio v-model="item.remind" label="不提醒">不提醒</el-radio>
              </div>
            </div>
            <div>答案：{{ item.answer || "暂无答案" }}</div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 10px"
          @click="dialogVisible = false"
        >关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination' // 引入分页器
import { recordList, recordDetail } from '@/api/question'

export default {
  name: 'GlobalNewParams',
  components: { Pagination },
  data() {
    return {
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      userTable: [],
      value1: '',
      dialogVisible: false,
      questionList: [],
      formData: {
        queNo: '',
        queName: '',
        count: 0,
        queTitle: ''
      },
      userPhone: '',
      userName: '',
      dateTime: '',
      loading: false
    }
  },
  mounted() {
    this.getList()
    // this.getSystemConfigmemo();
  },
  methods: {
    // 获取列表数据
    getList() {
      this.loading = true
      const time = this.dateTime
        ? [
          this.$parseTime(new Date(this.dateTime[0]), '{y}-{m}-{d}') +
              ' 00:00:00',
          this.$parseTime(new Date(this.dateTime[1]), '{y}-{m}-{d}') +
              ' 23:59:59'
        ]
        : ''
      var params = {
        pageNum: this.pageNumber,
        pageSize: this.pageSize,
        userName: this.userName,
        userPhone: this.userPhone,
        time: time
      }
      recordList(params)
        .then((res) => {
          console.log(res)
          this.userTable = res.rows
          this.total = res.count
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 下一页或刷新
    next() {
      this.$refs.gridTable.bodyWrapper.scrollTop = 0
      this.getList()
    },
    select() {
      this.pageNumber = 1
      this.getList()
    },
    // 关闭添加弹窗
    handleClose() {
      this.initForm()
    },
    initForm() {
      this.formData = {
        queNo: '',
        queName: '',
        count: 0,
        queTitle: ''
      }
    },
    checkEvent(item) {
      this.formData = { ...this.formData, ...item }
      recordDetail({ parentId: item.id }).then((res) => {
        this.dialogVisible = true
        this.questionList = res
        console.log('this.questionList', this.questionList)
      })
    },
    resetEvent() {
      this.userName = ''
      this.userPhone = ''
      this.dateTime = ''
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
#globalNewParams {
  .el-image {
    position: relative;
    display: inline-block;
    overflow: hidden;
    width: 100px;
    height: 100px;
  }

  .head_search {
    display: flex;
    width: 100%;
    margin-bottom: 20px;

    .item_warp {
      display: flex;

      .el-checkbox {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
      }

      label {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #525252;
        font-weight: 400;
      }
    }
  }

  .green {
    color: #00c759;
  }

  .red {
    color: rgb(255, 62, 51);
  }

  .el-tag + .el-tag {
    margin-left: 3px;
  }

  .button-new-tag {
    margin-left: 10px;
    margin-top: 5px;
    height: 25px;
    line-height: 25px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .zhi {
    margin: 0 0 10px 0;
    display: flex;
    align-items: center;
  }

  .el-tag--mini {
    height: 20px;
    padding: 0px 5px;
    line-height: 19px;
    margin: 0px 0 2px 0;
  }
  .set-tag {
    cursor: pointer;
    background: rgba(236, 236, 255, 1);
    // border: 1px solid rgba(236, 236, 255, 1) ;
    color: #6663ff;
    font-weight: bold;
  }
}
.questiontype {
  width: 400px;
  min-height: 100px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
}
.questiontype_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.questiontype_head_right {
  display: flex;
  align-items: center;
}
.questiontype_head_right_card {
  margin-left: 10px;
}
</style>
